export enum EventType {
  FW_AGENT_STATUS_IMPRESSION = 'fw:agent-status:impression',
}
